import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getCardsConfig() {
    return {
        palette: {
            [PALETTE_IDS.CARDS_AND_PROMOTIONS]: {
                CARD_WATERMARK_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PRICE_BOOST_BANNER]: {
                PRICE_BOOST_BANNER_CONTAINER_BG: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.EVENT_CARDS]: {
                CARD_FALLBACK_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_RACE_INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_EVENT_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_SPORT_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.PRE_BUILT_CARDS]: {
                CARD_MATCH_ACCA_BB_BET_ICON_COLOR: COLOR.BRAND.ACCENT2,
                CARD_MATCH_ACCA_SELECTION_ITEM: {
                    BB_BET_MARKET_TEXT: {
                        fontSize: FONT.SIZE_XXSMALL,
                    },
                },
                CARD_MATCH_ACCA_SELECTION_MARKET_NAME_TEXT: {
                    fontSize: FONT.SIZE_XXSMALL,
                },
                CARD_MATCH_ACCA_EVENT_INFO_TEXT: {
                    fontSize: FONT.SIZE_XXSMALL,
                    color: COLOR.BRAND.FOREGROUND2,
                },
            },
        },
    };
}
